export class UserSettings {
    LoggedIn: boolean
    Username: string 
    MachineKey:string
}